import { RARCS } from '../config'

export function getRarcLabelByCode(code: string) {
  const codeObj = RARCS.find((c) => c.code === code)
  return codeObj?.label ?? null
}
